var G2 = require('./core'); // geoms


require('./geom/interval');

require('./geom/line');

require('./geom/point');

module.exports = G2;


//////////////////
// WEBPACK FOOTER
// ./src/simple.js
// module id = 562
// module chunks = 1